import { useEffect, useState } from 'react'

// 画面右下のこの範囲にカーソルが入ったら、引っ込めた起動ボタンを半分だけ顔を出させる。
// 縦は起動ボタン(56px)と余白(24px)を合わせた占有領域より一回り広く取る。
// 横は画面右端に沿った移動で意図せず反応してしまうため、縦より狭くして
// 「呼び出したい」意図のあるカーソル移動だけを拾う。
const PROXIMITY_AREA_WIDTH = 60
const PROXIMITY_AREA_HEIGHT = 120

/**
 * 画面右下へのカーソル近接を検知するフック。
 *
 * ユーザーが起動ボタンを引っ込めた後、再び呼び出すための唯一の導線になる。
 * ポインタを持たない端末では検知できないため、呼び出し側で
 * 引っ込める操作自体を提供しないことで到達不能を防いでいる。
 *
 * @param isEnabled 起動ボタンを引っ込めている間だけ true にする。常設状態では監視不要なためリスナーを張らない。
 */
export const useFabProximity = (isEnabled: boolean): boolean => {
  const [isNearCorner, setIsNearCorner] = useState(false)

  useEffect(() => {
    if (!isEnabled) {
      setIsNearCorner(false)
      return
    }
    const handleMouseMove = (event: MouseEvent) => {
      setIsNearCorner(
        window.innerWidth - event.clientX <= PROXIMITY_AREA_WIDTH &&
          window.innerHeight - event.clientY <= PROXIMITY_AREA_HEIGHT
      )
    }
    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [isEnabled])

  return isNearCorner
}
